<template>
  <header v-bind:class="routeClass">
    <!-- Logo that links to the homepage -->
    <router-link to="/">
      <img :src="logoImage" />
    </router-link>

    <!-- Search -->
    <!-- <Search v-model="search"></Search> -->
    <div class="tabs" id="tabs">
      <!-- <router-link to="/overview" v-bind:class="{ active: overviewRoute }">
        Overview
      </router-link> -->
      <router-link
        to="/patient"
        v-bind:class="{ active: patientRoute }"
        v-bind:style="{ background: currentTabColor }"
      >
        Patients
      </router-link>
      <!-- <router-link to="/engagement" v-bind:class="{ active: engagementRoute }">
				Engagement
			</router-link> -->
      <router-link
        to="/outcome"
        v-bind:class="{ active: outcomeRoute }"
        class="outcome-tab"
        v-if="getUserType === 'observer'"
      >
        Outcomes
      </router-link>
    </div>

    <!-- Profile -->
    <el-dropdown
      class="profile"
      trigger="click"
      @command="switchCurrentProvider"
    >
      <span class="profile-wrap">
        <ProfileIcon class="profile-icon"></ProfileIcon>
        <span class="name">
          {{ getName }}
        </span>
        <i class="el-icon-arrow-down"></i>
      </span>
      <el-dropdown-menu class="dropdown navbar-dropdown" slot="dropdown">
        <el-dropdown-item command="logout">
          Log Out
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </header>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import RouteMixin from "../mixin/route";

import Search from "./search/Search";
import Icons from "./icon/components";

export default {
  mixins: [RouteMixin],
  props: {
    tabColor: {
      default: "#2d3e4f",
      type: String,
    },
  },
  data() {
    return {
      search: "",

      // UI flags
      profileDropdown: false,
      profileDropdownTimeout: null,
    };
  },

  mounted() {
    // this.$store.dispatch('getProfile')
  },

  computed: {
    ...mapGetters(["getUserType"]),
    ...mapGetters("user", ["getName"]),
    ...mapGetters("provider", ["getProviderName", "getCurrentProvider"]),
    currentTabColor() {
      if (
        this.getUserType === "observer" &&
        (this.$route.path === "/outcome" || this.$route.path === "/overview")
      )
        return "#F8F8F8";
      else if (this.getUserType === "observer") return "#1B62CD";
      return this.tabColor;
    },
    profile() {
      return this.$store.state.profile;
    },
    logoImage() {
      if (this.getUserType === "observer")
        return require("./image/safe_logo.png");
      return require("./image/logo.svg");
    },
    logoClass() {
      return process.env.NODE_ENV === "dev" ? "dev" : "prod";
    },
  },

  // Emit the standard `search` event when the search query changes
  watch: {
    search(query) {
      this.$store.state.globalSearch = query;
      this.$store.state.activeTab = "all";
      this.$emit("search", query);
    },
  },

  methods: {
    ...mapActions("provider", ["setCurrentProvider"]),

    // UI methods
    showDropdown() {
      clearTimeout(this.profileDropdownTimeout);
      this.profileDropdown = true;
    },
    hideDropdown() {
      this.profileDropdownTimeout = setTimeout(() => {
        this.profileDropdown = false;
      }, 400);
    },
    clickedDropdown(e) {
      e.stopPropagation();
      this.profileDropdown = false;
    },
    switchCurrentProvider(providerId) {
      if (providerId == "logout") this.$router.push("/logout");
      else {
        localStorage.setItem("provider", providerId);
        this.$router.push(
          { path: "/patient" },
          () => location.reload(),
          () => location.reload()
        );
      }
    },
  },

  components: {
    Search,
    ...Icons,
  },
};
</script>

<style lang="scss" scoped>
@import "../style-config.scss";
@import "style.scss";
</style>

<style>
.navbar-dropdown.el-popper .popper__arrow {
  display: none;
}
.navbar-dropdown.el-popper[x-placement^="bottom"] {
  margin-top: 0px;
}
</style>
